const slider = document.querySelector('.global-section-testimony__slider');

if (slider) {
    const cards = [...slider.querySelectorAll('.avis-card')];
    const total = cards.length;

    if (total > 1) {
        slider.style.scrollSnapType = 'none';

        let scrollPos    = 0;
        let paused       = false;
        let resumeTimer  = null;
        const speed      = 0.6; // px per frame
        const resumeDelay = 2500; // ms before resuming after interaction

        function getMaxScroll() {
            return Math.max(0, slider.scrollWidth - slider.clientWidth);
        }

        function pause() {
            paused = true;
            clearTimeout(resumeTimer);
        }

        function scheduleResume() {
            clearTimeout(resumeTimer);
            resumeTimer = setTimeout(() => {
                scrollPos = slider.scrollLeft; // reprend depuis la position de l'utilisateur
                paused = false;
            }, resumeDelay);
        }

        function animate() {
            if (!paused) {
                scrollPos += speed;

                const maxScroll = getMaxScroll();
                if (maxScroll > 0 && scrollPos >= maxScroll) {
                    scrollPos = 0;
                }

                slider.scrollLeft = scrollPos;
            }

            requestAnimationFrame(animate);
        }

        requestAnimationFrame(animate);

        slider.addEventListener('mouseenter', pause);
        slider.addEventListener('mouseleave', scheduleResume);
        slider.addEventListener('touchstart', pause, { passive: true });
        slider.addEventListener('touchend',   scheduleResume, { passive: true });
    }

    // Mask haut/bas sur le texte de chaque avis si son contenu déborde
    slider.querySelectorAll('.avis-card__text').forEach(textEl => {
        function updateMask() {
            const atStart = textEl.scrollTop <= 1;
            const atEnd   = textEl.scrollTop >= textEl.scrollHeight - textEl.clientHeight - 1;
            textEl.classList.toggle('is-start', atStart);
            textEl.classList.toggle('is-end', atEnd);
        }

        textEl.addEventListener('scroll', updateMask, { passive: true });
        updateMask();
    });
}
